<template>
  <div class="parallel-container">
    <loading :show="loadingShow"></loading>
    <Header></Header>
    <div class="pc" v-if="!isMobile">
      <div class="top">
        <div class="title">分会场联动</div>
        <div class="other flex">
          <div class="date flex">
            <img
              src="../../assets/images/agenda/time.png"
              alt=""
              class="icon"
            />
            <div class="text">2022年6月15 - 16日</div>
          </div>
          <div class="address flex">
            <img
              src="../../assets/images/agenda/address.png"
              alt=""
              class="icon"
            />
            <div class="text">全国分会场</div>
          </div>
        </div>
      </div>
      <div class="session-list">
        <div class="desc">
          <div class="title">20+省市近90个线下分会场</div>
          <div class="text">
            华为伙伴暨开发者大会2022面向全国伙伴和开发者，依托各省/地市华为代表处、产业云基地、联创中心、重点高校等资源举办近90个线下分会场。<br />
            大会在线上，相聚在身边，期待与您相见。
          </div>
        </div>
        <div class="operation flex justify-between">
          <div class="map">
            <div class="service-map">
              <svg-map
                :sessionsList="sessionsList"
                @selectOption="selectOption"
              ></svg-map>
              <!--              <img-->
              <!--                src="../../assets/images/parallelSessions/list/18-shandong.png"-->
              <!--                alt=""-->
              <!--              />-->
            </div>
          </div>
          <div class="list flex flex-direction align-center justify-center">
            <div
              @click="didClick_prev"
              v-show="now_session.now_AllList.length > 3"
              class="prev flex align-center justify-center"
              :class="{ 'prev-disable': now_session.now_Index <= 0 }"
            >
              <img
                :src="
                  now_session.now_Index <= 0
                    ? require('../../assets/images/parallelSessions/list/prev-disable.png')
                    : require('../../assets/images/parallelSessions/list/prev.png')
                "
                alt=""
              />
            </div>
            <div
              class="sessions flex flex-direction align-center"
              :class="{
                'justify-center': now_session.now_AllList.length < 3,
                'justify-start': now_session.now_AllList.length > 3,
              }"
              v-if="now_session.now_Index > -1"
            >
              <div
                class="session"
                v-for="(item, index) in now_session.now_ActiveList"
                :key="index"
              >
                <div class="name ellipsis-1" :title="item.name">
                  {{ item.name }}
                </div>
                <div class="other">
                  <div class="date flex">
                    <img
                      src="../../assets/images/agenda/time.png"
                      alt=""
                      class="icon"
                    />
                    <div class="text">{{ item.startDate }}</div>
                  </div>
                  <div class="address flex">
                    <img
                      src="../../assets/images/agenda/address.png"
                      alt=""
                      class="icon"
                    />
                    <div class="text ellipsis-1" :title="item.hotel">
                      {{ item.hotel }}
                    </div>
                  </div>
                </div>
                <div
                  class="more cs"
                  v-if="item.i_isSeeDeatil[0] !== '否'"
                  @click="lookMore(item)"
                >
                  查看详情 >>
                </div>
              </div>
            </div>
            <div
              @click="didClick_next"
              v-show="now_session.now_AllList.length > 3"
              class="next flex align-center justify-center cs"
              :class="{
                'next-disable':
                  now_session.now_Index + 3 >= now_session.now_AllList.length,
              }"
            >
              <img
                :src="
                  now_session.now_Index + 3 >= now_session.now_AllList.length
                    ? require('../../assets/images/parallelSessions/list/next-disable.png')
                    : require('../../assets/images/parallelSessions/list/next.png')
                "
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wap" v-if="isMobile">
      <div class="top">
        <div class="title">分会场联动</div>
        <div class="other flex">
          <div class="date flex">
            <img
              src="../../assets/images/agenda/time.png"
              alt=""
              class="icon"
            />
            <div class="text">2022年6月15 - 16日</div>
          </div>
          <div class="address flex">
            <img
              src="../../assets/images/agenda/address.png"
              alt=""
              class="icon"
            />
            <div class="text">全国分会场</div>
          </div>
        </div>
      </div>
      <div class="session-content">
        <div class="desc">
          <div class="title">20+省市近90个线下分会场</div>
          <div class="text">
            华为伙伴暨开发者大会2022面向全国伙伴和开发者，依托各省/地/市华为代表处、产业云基地、联创中心、重点高校等举办近90个线下分会场。<br />
            大会在线上，相聚在身边，期待与您相见。
          </div>
        </div>
        <div class="select-option">
          <el-select
            style="width: 100%; height: 100%"
            v-model="selectCity"
            @change="selectOptionWap"
            :popper-append-to-body="false"
          >
            <el-option
              style="
                width: 100%;
                height: 40px;
                padding-left: 14px;
                color: #000000;
              "
              class="no-option flex align-center"
              v-for="item in sessionsList_wap"
              :key="item.en"
              :label="item.value"
              :value="item.en"
            >
            </el-option>
          </el-select>
        </div>
        <div class="session-list" v-if="now_session.now_AllList.length > 0">
          <div
            class="session"
            v-for="(item, index) in now_session.now_AllList"
            :key="index"
          >
            <div class="name ellipsis-1">{{ item.name }}</div>
            <div class="other">
              <div class="date flex">
                <img
                  src="../../assets/images/agenda/time.png"
                  alt=""
                  class="icon"
                />
                <div class="text">{{ item.startDate }}</div>
              </div>
              <div class="address flex">
                <img
                  src="../../assets/images/agenda/address.png"
                  alt=""
                  class="icon"
                />
                <div class="text">{{ item.hotel }}</div>
              </div>
            </div>
            <div
              class="more cs"
              v-if="item.i_isSeeDeatil[0] !== '否'"
              @click="lookMore(item)"
            >
              查看详情 >>
            </div>
          </div>
        </div>
        <div class="nullData" v-else>
          <no-data :isHave="true"></no-data>
        </div>
      </div>
    </div>
    <suspension></suspension>
    <cook-tip></cook-tip>
    <foot></foot>
  </div>
</template>

<script>
import Header from "../../components/Header";
import Foot from "../../components/Foot";
import CookTip from "../../components/CookTip";
import { staticApi } from "../../services";
import { seminarAPI } from "@/services/modules/seminar";
import $store from "../../store";
import Suspension from "../../components/Suspension";
import svgMap from "../../components/parallelSessions/svgMap";
import dayjs from "dayjs";
import _ from "lodash";
export default {
  name: "Parallel",
  data() {
    return {
      sessionsList_o: [
        {
          id: 0,
          name: "安徽",
          value: "安徽省",
          en: "anhui",
          isHaveDetail: true,
          provincialCapital: "合肥",
          sessions: [],
        },
        {
          id: 0,
          name: "北京",
          value: "北京市",
          en: "beijing",
          isHaveDetail: true,
          provincialCapital: "北京",
          sessions: [],
        },
        {
          id: 0,
          name: "重庆",
          value: "重庆市",
          en: "chongqing",
          isHaveDetail: true,
          provincialCapital: "重庆",
          sessions: [],
        },
        {
          id: 0,
          name: "福建",
          value: "福建省",
          en: "fujian",
          isHaveDetail: false,
          provincialCapital: "福州",
          sessions: [],
        },
        {
          id: 0,
          name: "甘肃",
          value: "甘肃省",
          en: "gansu",
          isHaveDetail: false,
          provincialCapital: "兰州",
          sessions: [],
        },
        {
          id: 0,
          name: "广东",
          value: "广东省",
          en: "guangdong",
          isHaveDetail: true,
          provincialCapital: "深圳",
          sessions: [],
        },
        {
          id: 0,
          name: "广西",
          value: "广西壮族自治区",
          en: "guangxi",
          isHaveDetail: true,
          provincialCapital: "南宁",
          sessions: [],
        },
        {
          id: 0,
          name: "贵州",
          value: "贵州省",
          en: "guizhou",
          isHaveDetail: true,
          provincialCapital: "贵阳",
          sessions: [],
        },
        {
          id: 0,
          name: "海南",
          value: "海南省",
          en: "hainan",
          isHaveDetail: false,
          provincialCapital: "海口",
          sessions: [],
        },
        {
          id: 0,
          name: "河北",
          value: "河北省",
          en: "hebei",
          isHaveDetail: true,
          provincialCapital: "石家庄",
          sessions: [],
        },
        {
          id: 0,
          name: "河南",
          value: "河南省",
          en: "henan",
          isHaveDetail: false,
          provincialCapital: "郑州",
          sessions: [],
        },
        {
          id: 0,
          name: "黑龙江",
          value: "黑龙江省",
          en: "heilongjiang",
          isHaveDetail: false,
          provincialCapital: "哈尔滨",
          sessions: [],
        },
        {
          id: 0,
          name: "湖北",
          value: "湖北省",
          en: "hubei",
          isHaveDetail: true,
          provincialCapital: "武汉",
          sessions: [],
        },
        {
          id: 0,
          name: "湖南",
          value: "湖南省",
          en: "hunan",
          isHaveDetail: true,
          provincialCapital: "长沙",
          sessions: [],
        },
        {
          id: 0,
          name: "吉林",
          value: "吉林省",
          en: "jilin",
          isHaveDetail: true,
          provincialCapital: "长春",
          sessions: [],
        },
        {
          id: 0,
          name: "江苏",
          value: "江苏省",
          en: "jiangsu",
          isHaveDetail: true,
          provincialCapital: "南京",
          sessions: [],
        },
        {
          id: 0,
          name: "江西",
          value: "江西省",
          en: "jiangxi",
          isHaveDetail: true,
          provincialCapital: "南昌",
          sessions: [],
        },
        {
          id: 0,
          name: "辽宁",
          value: "辽宁省",
          en: "liaoning",
          isHaveDetail: true,
          provincialCapital: "沈阳",
          sessions: [],
        },
        {
          id: 0,
          name: "内蒙古",
          value: "内蒙古自治区",
          en: "neimenggu",
          isHaveDetail: true,
          provincialCapital: "呼和浩特",
          sessions: [],
        },
        {
          id: 0,
          name: "宁夏",
          value: "宁夏回族自治区",
          en: "ningxia",
          isHaveDetail: false,
          provincialCapital: "银川",
          sessions: [],
        },
        {
          id: 0,
          name: "青海",
          value: "青海省",
          en: "qinghai",
          isHaveDetail: true,
          provincialCapital: "西宁",
          sessions: [],
        },
        {
          id: 0,
          name: "山东",
          value: "山东省",
          en: "shandong",
          isHaveDetail: true,
          provincialCapital: "济南",
          sessions: [],
        },
        {
          id: 0,
          name: "山西",
          value: "山西省",
          en: "shanxi",
          isHaveDetail: true,
          provincialCapital: "太原",
          sessions: [],
        },
        {
          id: 0,
          name: "陕西",
          value: "陕西省",
          en: "shanxi2",
          isHaveDetail: true,
          provincialCapital: "西安",
          sessions: [],
        },
        {
          id: 0,
          name: "四川",
          value: "四川省",
          en: "sichuan",
          isHaveDetail: true,
          provincialCapital: "成都",
          sessions: [],
        },
        {
          id: 0,
          name: "天津",
          value: "天津市",
          en: "tianjin",
          isHaveDetail: true,
          provincialCapital: "天津",
          sessions: [],
        },
        {
          id: 0,
          name: "西藏",
          value: "西藏自治区",
          en: "xizang",
          isHaveDetail: true,
          provincialCapital: "拉萨",
          sessions: [],
        },
        {
          id: 0,
          name: "新疆",
          value: "新疆维吾尔自治区",
          en: "xinjiang",
          isHaveDetail: false,
          provincialCapital: "乌鲁木齐",
          sessions: [],
        },
        {
          id: 0,
          name: "云南",
          value: "云南省",
          en: "yunnan",
          isHaveDetail: true,
          provincialCapital: "昆明",
          sessions: [],
        },
        {
          id: 0,
          name: "浙江",
          value: "浙江省",
          en: "zhejiang",
          isHaveDetail: true,
          provincialCapital: "杭州",
          sessions: [],
        },
        {
          id: 0,
          name: "上海",
          value: "上海市",
          en: "shanghai",
          isHaveDetail: true,
          provincialCapital: "上海",
          sessions: [],
        },
        // {
        //   id: 0,
        //   name: "台湾",
        //   value: "台湾省",
        //   en: "taiwan",
        //   isHaveDetail: true,
        //   provincialCapital: "台湾",
        //   sessions: [],
        // },
        {
          id: 0,
          name: "香港",
          value: "香港特别行政区",
          en: "xianggang",
          isHaveDetail: true,
          provincialCapital: "香港",
          sessions: [],
        },
        {
          id: 0,
          name: "澳门",
          value: "澳门特别行政区",
          en: "aomen",
          isHaveDetail: true,
          provincialCapital: "澳门",
          sessions: [],
        },
      ],
      sessionsList: [],
      sessionsList_wap: [],
      currentIndex: -1,
      nowAgendas: [],
      isLoading: true,
      selectCity: "广东省",
      now_session: {
        now_Index: 0, //当前省份的会场下标
        now_AllList: [], //当前省份的搜易会议
        now_ActiveList: [], //当前省份的页面活跃会议
      },
      loadingShow: true,
      isMobile: false,
    };
  },
  components: {
    Header,
    Foot,
    CookTip,
    Suspension,
    svgMap,
    noData: () => import("../../components/common/no-data/noData.vue"),
  },
  created() {
    this.isMobile = document.body.clientWidth < 992;
    window.onresize = () => {
      this.isMobile = document.body.clientWidth < 992;
    };
    // this.sessionsList = _.cloneDeep(sessionsList);
  },
  mounted() {
    this.getSeminarList();
  },
  methods: {
    //获取会场列表
    getSeminarList() {
      seminarAPI
        .getSubSeminarList_onLine()
        .then((res) => {
          let sessionsListTemp = this.sessionsList_o;
          if (res.result == 0) {
            let SeminarList = res.content.items;
            //拿出主会场
            let now = SeminarList.filter((item) => {
              if (item.i_seminarid == "" || !item.i_seminarid) {
                return item;
              }
            }).forEach((item2) => {
              sessionsListTemp.forEach((city) => {
                if (item2.i_province[0] == city.name) {
                  item2.startDate = dayjs(item2.startTime * 1000).format(
                    "M月D日"
                  );
                  let endDate = dayjs(item2.endTime * 1000).format("M月D日");
                  if (endDate !== item2.startDate) {
                    item2.startDate =
                      dayjs(item2.startTime * 1000).format("M月D") +
                      dayjs(item2.endTime * 1000).format("-D日");
                  }
                  city.sessions.push(item2);
                }
              });
            });
            //广东省 深圳分会场排第一 begin
            // let gd_index = -1;
            // let obj = {};
            // sessionsListTemp.forEach((item, index) => {
            //   if (item.en == "guangdong") {
            //     gd_index = index;
            //     item.sessions.forEach((item2, index2) => {
            //       if (item2.name.indexOf("深圳") > -1) {
            //         obj = item2;
            //         item.sessions.splice(index2, 1);
            //         return;
            //       }
            //     });
            //   }
            // });
            // sessionsListTemp[gd_index].sessions.unshift(obj);
            //广东省 深圳分会场排第一 begin
            this.sessionsList = sessionsListTemp;
            if (this.$store.state.isMobile) {
              this.dataCollation(sessionsListTemp);
            }
            this.getIndex("guangdong");
            this.loadingShow = false;
          }
        })
        .catch((err) => {
          console.log("获取分会场列表失败", err);
          this.loadingShow = false;
        });
    },
    //获取下标
    getIndex(en) {
      let index = -1;
      let sessionsList = this.sessionsList;
      let nowSession = [];
      let nowSession2 = [];
      //按照省会第一个 排第一位，其他按照开始时间排序 begin
      let obj = null;
      for (let i = 0; i < sessionsList.length; i++) {
        if (sessionsList[i].en == en) {
          nowSession = sessionsList[i].sessions;
          nowSession.forEach((item) => {
            item.i_meetOrder2 = item.i_meetOrder ? Number(item.i_meetOrder) : 0;
          });
          nowSession2 = nowSession.sort(function (a, b) {
            return b.i_meetOrder2 - a.i_meetOrder2;
          });
          break;
        }
      }
      this.currentIndex = index;
      this.now_session = {
        now_Index: 0,
        now_AllList: nowSession && nowSession.length ? nowSession : [],
        now_ActiveList:
          nowSession && nowSession.length ? nowSession.slice(0, 3) : [],
      };
    },
    //svg 选择
    selectOption(id) {
      this.getIndex(id);
    },
    //WAP 下拉选择
    selectOptionWap(e) {
      this.getIndex(e);
    },
    //上下箭头
    didClick_prev() {
      if (this.now_session.now_Index <= 0) {
        return false;
      }
      let index = (this.now_session.now_Index = this.now_session.now_Index - 1);
      //队列替换
      this.now_session.now_ActiveList = this.now_session.now_AllList.slice(
        index,
        index + 3
      );
    },
    didClick_next() {
      if (
        this.now_session.now_Index + 3 >=
        this.now_session.now_AllList.length
      ) {
        return false;
      }
      let index = (this.now_session.now_Index = this.now_session.now_Index + 1);
      //队列替换
      this.now_session.now_ActiveList = this.now_session.now_AllList.slice(
        index,
        index + 3
      );
    },
    //跳转 详情
    lookMore(option) {
      //埋码
      window._hw("send", "action", "branch_venue_page_check_more_venue_click", {
        venue_name: option.name,
      });
      this.$router.push({
        path: "/parallel-detail",
        query: { seminarId: option.subSeminarId, i_offlineArea: option.name },
      });
    },
    /**
     * @description 数据二次整理,会场为空、在指定的某几个会场 不显示
     * @param {list} 整理前 会场列表
     * @returns sessionsList 整理后 会场列表
     */
    dataCollation(list) {
      let newlist = list.filter((item) => {
        if (item.sessions.length == 0) {
          return false;
        }
        return item;
      });
      this.sessionsList_wap = newlist;
    },
  },
  destroyed() {
    this.now_session = {
      now_Index: 0, //当前省份的会场下标
      now_AllList: [], //当前省份的搜易会议
      now_ActiveList: [], //当前省份的页面活跃会议
    };
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 992px) {
  //@import "./css/index/pc.scss";
  .parallel-container {
    min-height: 100vh;
    width: 100%;
    background-color: #e3e9f5;
    background-image: url("../../assets/images/guest/rightImg.png");
    background-repeat: no-repeat;
    background-position: calc(100vw - 490px) 28px;
    background-size: 490px 326px;
    .pc {
      min-height: 100vh;
      .top {
        position: relative;
        width: 1500px;
        margin: 0 auto;
        z-index: 1;
        padding-top: 70px;
        padding-bottom: 84px;

        .title {
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: 700;
          font-size: $font-xxxxl;
          color: #151e26;
          margin-top: 15px;
        }
        .other {
          width: 100%;
          box-sizing: border-box;
          padding-top: 14px;
          padding-bottom: 16px;
          .date {
            .icon {
              width: 18.75px;
              height: 18.75px;
              border-radius: 50%;
              margin-right: 11px;
            }
            .text {
              font-size: 20px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 1;
            }
          }
          .address {
            margin-left: 50px;
            .icon {
              width: 20px;
              height: 20px;
              margin-right: 7px;
            }
            .text {
              width: auto;
              font-size: 20px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 1;
            }
          }
        }
      }
      .session-list {
        z-index: -1;
        margin-top: -30px;
        padding: 63px 357px;

        width: 100%;
        background: #e9ecf9;
        box-shadow: inset -2px -2px 2px 1px rgba(255, 255, 255, 0.25);
        .desc {
          margin-left: 30px;
          width: 1500px;
          margin-left: -145px;
          .title {
            font-size: 20px;
            font-family: Microsoft YaHei-Light;
            font-weight: 600;
            color: #333333;
            line-height: 30px;
          }
          .text {
            margin-top: 15px;
            font-size: 18px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
          }
        }
        .operation {
          width: 1203px;
          margin-top: 38px;
          .map {
            width: 941px;
            height: 774px;
            position: relative;
            .service-map {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 1;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .list {
            width: 250px;
            height: 774px;

            .prev {
              user-select: none;
              cursor: pointer;
              width: 230px;
              height: 40px;
              background: #f6f7f9;
              z-index: 2;
              img {
                width: 18.5px;
                height: 11px;
              }
            }
            .prev-disable {
              cursor: not-allowed;
              background: #f6f7f9;
            }
            .next {
              user-select: none;
              cursor: pointer;
              width: 230px;
              height: 40px;
              background: #f6f7f9;
              z-index: 2;
              img {
                width: 18.5px;
                height: 11px;
              }
            }
            .next-disable {
              cursor: not-allowed;
              background: #f6f7f9;
            }
            .sessions {
              z-index: 1;
              width: 250px;
              overflow: hidden;
              overflow-y: hidden;
              position: relative;
              .session {
                width: 230px;
                height: 156px;
                margin-bottom: 29px;
                padding-bottom: 16px;
                background: #f2f4fa;
                box-shadow: 0px 0px 15px 1px rgba(93, 96, 114, 0.1);
                .name {
                  width: 230px;
                  height: 40px;
                  background: rgba(255, 255, 255, 0.2);
                  box-shadow: 0px 0px 15px 1px rgba(93, 96, 114, 0.1);
                  opacity: 1;
                  border: 1px solid;
                  border-image: linear-gradient(
                      164deg,
                      rgba(255, 255, 255, 1),
                      rgba(235, 235, 235, 0)
                    )
                    1 1;
                  padding-top: 8px;
                  padding-left: 24px;
                  padding-right: 24px;
                  font-size: 16px;
                  font-family: Microsoft YaHei-Light;
                  font-weight: 600;
                  color: #666666;
                  line-height: 24px;
                }
                .other {
                  width: 100%;
                  box-sizing: border-box;
                  padding-top: 14px;
                  padding-left: 25px;
                  padding-bottom: 16px;
                  .date {
                    .icon {
                      width: 15px;
                      height: 15px;
                      margin-right: 7px;
                      border-radius: 50%;
                    }
                    .text {
                      font-size: 14px;
                      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                      font-weight: 400;
                      color: #666666;
                      line-height: 1;
                    }
                  }
                  .address {
                    margin-top: 12px;
                    .icon {
                      width: 16px;
                      height: 16px;
                      margin-right: 9px;
                    }
                    .text {
                      width: 100%;
                      padding-right: 25px;
                      font-size: 14px;
                      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                      font-weight: 400;
                      color: #666666;
                      line-height: 1;
                    }
                  }
                }
                .more {
                  margin-left: 25px;
                  font-size: 14px;
                  font-family: Microsoft YaHei-Light, Microsoft YaHei;
                  font-weight: 300;
                  color: #b4251e;
                  line-height: 30px;
                  text-decoration: underline;
                }
              }
              .session:first-child {
                margin-top: 21px;
              }
              .session:last-child {
                margin-bottom: 21px;
              }
              .session:hover {
                box-shadow: 0px 0px 15px 1px rgba(180, 37, 30, 0.2);
                .name {
                  width: 230px;
                  height: 40px;
                  background: rgba(255, 255, 255, 0.2);
                  box-shadow: 0px 0px 15px 1px rgba(93, 96, 114, 0.1);
                  opacity: 1;
                  border: 1px solid;
                  border-image: linear-gradient(
                      164deg,
                      rgba(255, 255, 255, 1),
                      rgba(235, 235, 235, 0)
                    )
                    1 1;
                  padding-top: 8px;
                  padding-left: 24px;
                  font-size: 16px;
                  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                  color: #b4251e;
                  line-height: 24px;
                  font-weight: 700;
                }
              }
            }
          }
        }
      }
    }
    .wap {
      display: none;
    }
  }
}

@media screen and (max-width: 992px) {
  //@import "./css/index/wap.scss";
  .parallel-container {
    min-height: 100vh;
    width: 100%;
    background-color: #e3e9f5;
    background-image: url("../../assets/images/bg-mobile.png"),
      url("../../assets/images/parallelSessions/list/footbg-wap.png");
    background-repeat: no-repeat, no-repeat;
    background-position: top right, bottom left;
    background-size: 750px, 391px 602px;

    .pc {
      display: none;
    }

    .wap {
      min-height: calc(100vh - 350px);

      .top {
        width: 100%;
        height: calc(367px - 110px);
        padding-left: 35px;
        padding-right: 35px;
        position: relative;

        .title {
          position: absolute;
          bottom: 106px;
          font-size: 44px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: 700;
          color: #151e26;
        }

        .other {
          position: absolute;
          bottom: 20px;
          width: 90%;
          box-sizing: border-box;
          padding-top: 14px;
          padding-bottom: 16px;
          display: flex;
          flex-direction: column;

          .date {
            .icon {
              width: 22.5px;
              height: 22.5px;
              border-radius: 50%;
              margin-right: 14px;
            }

            .text {
              font-size: 24px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 1;
            }
          }

          .address {
            margin-top: 13px;

            .icon {
              width: 24px;
              height: 24px;
              margin-right: 8px;
            }

            .text {
              width: auto;
              font-size: 24px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 1;
            }
          }
        }
      }

      .session-content {
        width: 100%;
        padding-top: 62px;

        .desc {
          width: calc(100% - 70px);
          margin-left: 35px;
          padding-bottom: 49px;
          border-bottom: 1px solid #bbbbbb;
          .title {
            font-size: 28px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: 700;
            color: #333333;
          }

          .text {
            margin-top: 20px;
            font-size: 24px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            text-align: justify;
            word-break: break-all;
            text-justify: distribute;
          }
        }
        .select-option {
          width: calc(100% - 70px);
          height: 80px;
          margin-top: 53px;
          margin-left: 35px;
          .no-select {
            font-size: 28px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #000000;
          }
          /* 自定义宽度 */
          ::v-deep .el-select {
            width: 100%;
            height: 100%;
            .el-input .el-input__inner {
              padding-left: 50px;
              border: none;
              font-size: 28px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #000000;
              background: rgba(255, 255, 255, 0.4);
              border: 1px solid;
              border-image: linear-gradient(
                  164deg,
                  rgba(255, 255, 255, 1),
                  rgba(235, 235, 235, 0)
                )
                1 1;
            }
            .el-select .el-input__inner:focus {
              border: none;
            }
            /* selecte 框的高度设置，默认是 40px*/
            .el-input {
              height: 100% !important;

              .el-input__inner {
                height: 100% !important;
              }
            }

            /* 下面设置右侧按钮居中 */
            .el-input__suffix {
              /*很关键：将默认的select选择框样式清除*/
              right: 24px;
              .el-input__suffix-inner {
                i::before {
                  width: 30px;
                }
              }
            }
          }
          ::v-deep .el-select .el-input .el-select__caret {
            color: #8a8a8a;
            font-size: 40px;
            //height: 20px;
            height: 40px;
            width: 45px;
            text-align: center;
            margin-top: 20px;
          }
          //修改总体选项的样式 最外层
          ::v-deep .el-select-dropdown {
            padding: 20px;
            margin-top: 20px;
          }
          //修改单个的选项的样式
          ::v-deep .el-select-dropdown__item {
            background-color: transparent;
            color: #fff;
            font-size: 28px;
          }
        }
        .session-list {
          width: 100%;
          padding: 10px 35px 100px 35px;
          .session {
            width: 100%;
            margin-top: 30px;
            padding-bottom: 67px;
            background: #f2f4fa;
            box-shadow: 0px 0px 15px 1px rgba(93, 96, 114, 0.1);
            .name {
              text-align: left;
              width: 100%;
              height: 89px;
              line-height: 89px;
              background: rgba(255, 255, 255, 0.2);
              box-shadow: 0px 0px 15px 1px rgba(93, 96, 114, 0.1);
              padding-left: 50px;
              padding-right: 50px;
              font-size: 28px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: 700;
              color: #151e26;
            }
            .other {
              width: 100%;
              box-sizing: border-box;
              padding-top: 37px;
              padding-left: 50px;
              padding-bottom: 28px;
              display: flex;
              flex-direction: row;
              .date {
                .icon {
                  margin-top: 6px;
                  width: 22.5px;
                  height: 22.5px;
                  margin-right: 14px;
                  border-radius: 50%;
                }
                .text {
                  margin-top: 6px;
                  width: 140px;
                  font-size: 24px;
                  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                  font-weight: 400;
                  color: #666666;
                  line-height: 1;
                }
              }
              .address {
                margin-left: 12px;
                align-items: flex-start;
                .icon {
                  width: 24px;
                  height: 24px;
                  margin-right: 8px;
                  margin-top: 6px;
                }
                .text {
                  width: 300px;
                  font-size: 24px;
                  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                  font-weight: 400;
                  color: #666666;
                  line-height: 1.5;
                }
              }
            }
            .more {
              margin-left: 50px;
              font-size: 24px;
              font-family: Microsoft YaHei-Light, Microsoft YaHei;
              font-weight: 300;
              color: #b4251e;
              line-height: 30px;
              text-decoration: underline;
            }
          }
        }
        .nullData {
          width: 100%;
          height: 648px;
        }
      }
    }
  }
}
</style>
